module.exports = __webpack_public_path__ + "static/giant-head-641928d47ceba828caf5604c498c480b.jpg";